<template>
    <model-modal
        component="v-spa-mixed-modal"
        :model-class="modelClass"
        modal-type="form"
        @opening="onOpening"
        @opened="onOpened"
        @resetted="onReset"
        ref="modal"
        class="vm--container--overflowable"
    >
        <template v-slot:default="slotProps">
            <h2 class="mb-8 text-xl font-thin text-center text-gray-800">
                {{ slotProps.model ? $t(`modals.worksite-phase.edit_title`) : $t(`modals.worksite-phase.create_title`) }}
            </h2>
            <form @submit.prevent="submit" class="mx-auto max-w-input">
            
                <v-spa-input ref="inputTitle" id="worksite-phase-form-title" :form="form" input-name="title"></v-spa-input>

                <v-spa-submenu-container container="absolute z-[100] bottom-full left-0 shadow-lg bg-white whitespace-nowrap rounded" ref="datesSubmenu">
                    <template v-slot:default="slotProps">
                        <v-spa-label :form="form" id="worksite-phase-form-dates" :label="$t('worksite.form.labels.dates')"></v-spa-label>
                        <div :class="`${$spa.css.form.input} flex mb-6 cursor-pointer items-center`" @click.prevent="onDatesClick">
                            <div class="mr-4">
                                <i class="text-lg text-gray-700 fas fa-calendar"></i>
                            </div>
                            <div>
                                <span class="text-sm text-gray-700">{{ $t('worksite.form.labels.selected_dates', {start: $moment(form.starts_at).format('DD MMMM YYYY'), end: $moment(form.ends_at).format('DD MMMM YYYY')}) }}</span>
                            </div>
                        </div>
                    </template>
                    <template v-slot:submenu>
                        <div class="w-auto">
                            <date-picker
                                class="!border-0"
                                v-model="range"
                                mode="range" 
                                :is-inline="true"
                                :locale="$i18n.locale"
                                :attributes="[
                                    {
                                        key: 'today',
                                        dot: true,
                                        dates: new Date(),
                                    },
                                ]"
                                :columns="2"
                                :step="1"
                                @input="dateSelected"
                            />
                        </div>
                    </template>
                </v-spa-submenu-container>
                
                <div class="flex justify-end">
                    <v-spa-loading-button :loading="form.isLoading()">
                        <i class="mr-2 far fa-check"></i>
                        {{ slotProps.model ? $t(`modals.worksite-phase.edit_button`) : $t(`modals.worksite-phase.create_button`) }}
                    </v-spa-loading-button>
                </div>
            </form>
        </template>
    </model-modal>
</template>

<style>
    .vm--container--overflowable .vm--modal {
        overflow: visible !important;
    }
</style>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import WorksitePhase from '@spa/apps/trustup-pro-worksite-js/models/WorksitePhase';
    import Form from '~spa/classes/Form';
    import DatePicker from 'v-calendar/lib/components/date-picker.umd';

    export default {
        components: {
            DatePicker,
            ModelModal
        },

        data() {
            return {
                modelClass: WorksitePhase,
                range: null,
                worksite: null,
                form: new Form({
                    title: '',
                    starts_at: null,
                    ends_at: null
                })
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal.model;
            },
        },

        methods: {
            onOpening(data)
            {
                if ( data.worksite ) {
                    this.worksite = data.worksite;
                    this.form.title = data.worksite.title;
                    this.form.starts_at = data.worksite.starts_at;
                    this.form.ends_at = data.worksite.ends_at;
                }

                if ( data.defaultTitle ) {
                    this.form.title = data.defaultTitle;
                } 

                if ( this.model ) {
                    this.form.title = this.model.title;
                    this.form.starts_at = this.model.starts_at;
                    this.form.ends_at = this.model.ends_at;
                }
            },

            async onOpened()
            {
                await this.$nextTick();
                await this.$nextTick();
                this.$refs.inputTitle.$refs.input.focus();
            },

            onReset()
            {
                this.form.reset();
                this.form.stop();
                this.worksite = null;
            },
            
            setRange()
            {
                this.range = {
                    start: window.moment(this.form.starts_at).toDate(),
                    end: window.moment(this.form.ends_at).toDate()
                };
            },

            onDatesClick()
            {
                this.setRange();
                this.$refs.datesSubmenu.show();
            },

            dateSelected(event)
            {
                this.form.starts_at = window.moment(event.start).format('YYYY-MM-DD');
                this.form.ends_at = window.moment(event.end).format('YYYY-MM-DD');
                // this.setRange();
                // this.$refs.datesSubmenu.hide();
            },

            getFormData()
            {
                return this.model 
                    ? {uuid: this.model.uuid, data: this.form.data()}
                    : this.form.data();
            },

            async submit()
            {
                if ( this.form.isLoading() ) {
                    return;
                }

                this.form.load();
                let method = this.model ? 'update' : 'store';
                
                await window.Worksite.endpoints.worksitePhase
                    .setWorksite(this.worksite)
                    [method](this.getFormData());

                this.$refs.modal.close();
            },

        }
    }
</script>